import { render, staticRenderFns } from "./PWChange.vue?vue&type=template&id=0cb2f190&scoped=true&"
import script from "./PWChange.vue?vue&type=script&lang=js&"
export * from "./PWChange.vue?vue&type=script&lang=js&"
import style0 from "./PWChange.vue?vue&type=style&index=0&id=0cb2f190&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb2f190",
  null
  
)

export default component.exports